module.exports = __webpack_public_path__ + "img/DSC_0085_1-3.00698d62.jpeg";